<template>
  <div class="base-info">
    <div class="head-name">
      <div>
        <img :src="userInfo.avatarUrl || require('@/assets/image/user-image.png')" alt="" class="avatar-url"
          @error="errimg()" />
      </div>
      <div class="name-position">
        <div class="weight-bold">{{ userInfo.userName }} {{ userInfo.userMobile }}</div>
        <div class="position ellipsis--l2">
          {{ userInfo.unitPosition }}</div>
      </div>
    </div>
    <div>
      <div class="rule-info" @click="showRuleInfo">
        <i class="el-icon-question info-icon"/>
        <div class="tip-text">规则说明</div>
      </div>
      <div class="code-info">
        <div>
          <i class="iconfont icerweima qr-code" :style="`color: ${codeColors[ruleInfo.finalCode || 0]}`" />
        </div>
        <div class="score-info">
          <div v-for="(x, i) in codeRuleList" :key="i" class="score-item">
            <div class="score-tip">{{ x.yearStr }}{{ x.codeRule }}</div>
            <span>
              <span class="weight-bold" :style="`color: ${partColors[x.codeType || 0]}`">{{ x.gainCredit }}</span>
              <span v-if="x.needShowStandardScore == 1"> / {{ x.examCreditStr }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { userCodeInfo } from '@/api/resourceService'
import { userDetail } from "@/api/user";
export default {
  props: {},
  components: {},
  data() {
    return {
      codeColors: ['#b9c1e2', '#15be50', '#ffaa3c', '#f8674d'],
      // 1绿码 2黄码 3红码
      partColors: ['#51627d', '#15be50', '#ffaa3c', '#f8674d'],
      ruleInfo: {},
      codeRuleList: [],
      userInfo: {},
    };
  },
  computed: {
    userId(vm) {
      return vm.$route.query.uuid;
    },
  },
  mounted() {
    userCodeInfo(this.userId).then(({ code, data }) => {
      if (code !== 0) return
      console.log('data :>> ', data);
      this.ruleInfo = data;
      const { codeRuleList = [] } = data;
      this.codeRuleList = codeRuleList
    })
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      userDetail(this.userId).then(({code ,data = {}}) => {
        if (code === 0) {
          this.userInfo = {
            avatarUrl: data.avatarUrl,
            userName: data.userName,
            userMobile: data.userMobile,
            unitPosition: data.unitPosition,
          };
        }
      });
    },
    errimg() {
      let img = event.srcElement;
      img.src = require("@/assets/image/user-image.png");
      img.onerror = null;
    },
    showRuleInfo() {
      this.$emit('showRuleInfo')
    }
  }
}
</script>
<style lang='scss' scoped>
.base-info {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
}

.head-name {
  display: flex;
  flex: 1;
}

.name-position {
  width: 60%;
  padding-top: 12px;
  padding-left: 10px;
  font-size: 18px;
}

.position {
  margin-top: 10px;
}

.code-info {
  display: flex;
}

.score-info {
  padding: 9px 10px 0 15px;
}

.score-item {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}

.score-tip {
  margin-right: 20px;
}

.avatar-url {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.qr-code {
  font-size: 55px;
}

.weight-bold {
  font-weight: bold;
}

.rule-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  margin-right: 8px;
  color: #3A85FF;
  cursor: pointer;
  .info-icon {
    font-size: 18px;
  }
  .tip-text {
    margin-left: 4px;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>